import { inject } from '@angular/core';
import { CanActivateFn, GuardResult, Router } from '@angular/router';
import { AuthStore } from '../auth/store/auth-store';

/**
 * A `CanActivate` guard that only allows the activation of a route, if the user is unauthenticated. Authenticated
 * users will instead be redirected to the `redirectUrl`.
 * @param redirectUrl The `URL` to which authenticated users should be redirected to.
 */
export const canActivateIfUnauthenticated: (redirectUrl: string) => CanActivateFn = (redirectUrl: string): CanActivateFn => {
    return async (): Promise<GuardResult> => {
        const authStore: AuthStore = inject(AuthStore);
        const router: Router = inject(Router);

        await authStore.authStateReady();

        return !!authStore.user()
            ? router.createUrlTree([ redirectUrl ])
            : true;
    };
};